import { gql } from '@apollo/client';

export const USER_CREATE = gql`
  mutation createUserMutation($email: String!, $password: String!, $profile: JSON!) {
    createUser(email: $email, password: $password, profile: $profile) {
      token
      user {
        _id
        profile {
          language
        }
        userHash
        monday
      }
    }
  }
`;

export const USER_DETAILS_UPDATE = gql`
  mutation userUpdate($id: String!, $profile: ProfileInput!) {
    updateUser(user: { id: $id, profile: $profile }) {
      emails {
        address
      }
      profile {
        companyname
      }
    }
  }
`;

export const USER_PASSWORD_UPDATE = gql`
  mutation userPassword($oldPassword: String!, $newPassword: String!) {
    updatePassword(data: { oldPassword: $oldPassword, newPassword: $newPassword })
  }
`;

export const USER_SETTINGS_UPDATE = gql`
  mutation userUpdate(
    $id: String!
    $profile: ProfileInput!
    $domain: String!
    $ptype: String!
    $otherptype: String
    $sigtype: String
    $sigOptions: [String!]
    $contactOptions: [ContactOptionsInput!]
    $signature: String
    $cname: String
    $dns: String
    $signatureEmails: [String!]
    $expiry: String
    $uploadedFonts: [UploadedFontsInput!]
    $branding: BrandInput
  ) {
    updateUser(
      user: {
        id: $id
        profile: $profile
        domain: $domain
        ptype: $ptype
        otherptype: $otherptype
        sigtype: $sigtype
        sigOptions: $sigOptions
        contactOptions: $contactOptions
        signature: $signature
        cname: $cname
        dns: $dns
        signatureEmails: $signatureEmails
        expiry: $expiry
        uploadedFonts: $uploadedFonts
        branding: $branding
      }
    ) {
      profile {
        companyname
        enableAITool
      }
      branding {
        brandName
        companyLogo
        buttonColor
        buttonTextColor
        font
      }
    }
  }
`;

export const USER_UPDATE = gql`
  mutation userUpdate($user: UserInput!) {
    updateUser(user: $user) {
      _id
      emails {
        address
      }
      profile {
        name
        companyname
        address
        vatnumber
        contactnumber
        whatsappNumber
        image
        terms
        priceSeperator
        decimalPrecision
        currency
        redirectAfter
        redirectTo
        contactButton
        callButton
        dateFormat
        role
        firstPayment
        affiliate
        infoUpdate
        allowPreviewDownload
        showPdfFooter
        pdfFooterVariables
        enableAITool
        defaultProposalFont
        seenTour
        onboardingState
        onBoardComplete
      }
      otherptype
      config
      ptype
      teamId
      freshbooks
      domain
      sigtype
      sigOptions
      contactOptions {
        option
        value
        enabled
      }
      signature
      signatureEmails
      defaultLogo
      credits
      paypalId
      deletedTemplates
      affiliatePayments {
        requestedCredits
        paided
        createdAt
        payedAt
      }
      reviewWidget
      userway
      templateFilter
      uploadedFonts {
        family
        weights
        source
        title
        format
        url
      }
      branding {
        brandName
        companyLogo
        buttonColor
        buttonTextColor
        font
      }
    }
  }
`;

export const USER_RESET_PASSWORD = gql`
  mutation resetPasswordMutation($token: String!, $newPassword: String!) {
    resetPassword(token: $token, newPassword: $newPassword)
  }
`;

export const USER_FORGOT_PASSWORD = gql`
  mutation forgotPasswordMutation($email: String!) {
    forgotPassword(email: $email)
  }
`;

export const USER_DELETE = gql`
  mutation userDeleteMutation {
    deleteUser
  }
`;

export const USER_TOGGLE_2FA = gql`
  mutation toggle2FAMutation(
    $userId: String!
    $value: Boolean!
    $recoveryToken: String!
    $twoFASecret: String!
  ) {
    toggle2FA(
      userId: $userId
      value: $value
      recoveryToken: $recoveryToken
      twoFASecret: $twoFASecret
    ) {
      profile {
        enable2FA
      }
    }
  }
`;
export const USER_VERIFY_TOTP = gql`
  mutation verifyTOTPMutation($userId: String!, $otp: String!, $secretKey: String) {
    verifyTOTP(userId: $userId, otp: $otp, secretKey: $secretKey)
  }
`;
export const USER_GENERATE_TOTP = gql`
  mutation generateTOTP($userId: String!) {
    generateTOTP(userId: $userId) {
      manualKey
      qrCodeUrl
      recoveryToken
    }
  }
`;

export const USER_MFA_RECOVERY = gql`
  mutation recoverMFAUserMutation($userId: String!, $recoveryToken: String!) {
    recoverMFAUser(userId: $userId, recoveryToken: $recoveryToken)
  }
`;

// Revokes the current auth token server-side (see prospero-gql `logout`
// mutation). Without this, logging out only cleared local state and the
// still-valid JWT could be replayed directly against the API.
export const USER_LOGOUT = gql`
  mutation userLogoutMutation {
    logout
  }
`;
